export default {
    //中文
    DiagnosticReport:'诊断报告',
    troubleCode:'故障码',
    time:'时间',
    // 语言
    lang:{
        cn:'中文',
        de:'德语',
        en:'英语',
        es:'西班牙语',
        fr:'法语',
        it:'意大利语',
        ja:'日语',
        ko:'韩语',
        pt:'葡萄牙语'
    }
}